import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { getCssPropertyAsNumber } from '@/utilities/style-helper';
import { ref, watch } from 'vue';

  const iconHeight = 40;
  const dragThreshold = 10
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFloatingIcon',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  emits: [
    'onClick',
    'update:isVisible'
  ],
  setup(__props, { emit }) {

const props = __props;



  

  const startingPos = {
    top: window.innerHeight - iconHeight - getCssPropertyAsNumber("--ion-safe-area-bottom") - 20, // 20 is the margin
    left: window.innerWidth - iconHeight - 20
  };

  //Variables
  const floatingButton = ref();
  const isDragging = ref(false)
  const dragStarted = ref(false)
  const position = ref(startingPos);
  const startOffset = ref({
    x: 0,
    y: 0
  })

  //Watchers
  watch(() => props.isVisible, (newValue: boolean) => {
      if(!newValue) {
        removeEventListeners();
      }
    },
    {
      immediate: true
    }
  )

  //Methods
  function startDrag(event: any) {
    isDragging.value = false;
    dragStarted.value = false;
    startOffset.value = {
      x: (event.clientX || event.touches[0].clientX) - position.value.left,
      y: (event.clientY || event.touches[0].clientY) - position.value.top
    };
    floatingButton.value.addEventListener('mousemove', onDrag);
    floatingButton.value.addEventListener('mouseup', stopDrag);
    floatingButton.value.addEventListener('touchmove', onDrag);
    floatingButton.value.addEventListener('touchend', stopDrag);
  }

  function onDrag(event: any) {
    const clientX = event.clientX || event.touches[0].clientX;
    const clientY = event.clientY || event.touches[0].clientY;
    const dx = clientX - startOffset.value.x - position.value?.left ?? 0;
    const dy = clientY - startOffset.value.y - position.value?.top ?? 0;

    if (Math.abs(dx) > dragThreshold || Math.abs(dy) > dragThreshold) {
      isDragging.value = true;
      dragStarted.value = true;
    }

    if (isDragging.value) {
      position.value = {
        top: clientY - startOffset.value.y,
        left: clientX - startOffset.value.x
      };
    }
    event.preventDefault();
    event.stopPropagation();
  }
  const offset = iconHeight / 2;
  function isElementVisible(element: HTMLElement) {
      const rect = element.getBoundingClientRect();

      // Check if the element is within the viewport
      if (
          rect.top + offset >= 0 &&
          rect.left + offset >= 0 &&
          rect.bottom - offset <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right - offset <= (window.innerWidth || document.documentElement.clientWidth)
      ) {
          // Check if the element is visible and not covered by another element
          const centerX = (rect.left + rect.right) / 2;
          const centerY = (rect.top + rect.bottom) / 2;

          const topmostElement = document.elementFromPoint(centerX, centerY);

          // Ensure the element is the topmost at its center point
          if (topmostElement === element || element.contains(topmostElement)) {
              return true;
          }
      }
      return false;
  }

  function stopDrag(event: any) {
    floatingButton.value.removeEventListener('mousemove', onDrag);
    floatingButton.value.removeEventListener('mouseup', stopDrag);
    floatingButton.value.removeEventListener('touchmove', onDrag);
    floatingButton.value.removeEventListener('touchend', stopDrag);

    if (!dragStarted.value) {
      emit('onClick')
      emit('update:isVisible', false);
    }

    isDragging.value = false;
    dragStarted.value = false;

    if(!isElementVisible(floatingButton.value as HTMLElement)) {
      position.value = startingPos;
    }
  }

  function removeEventListeners() {
    document.removeEventListener('mousemove', onDrag);
    document.removeEventListener('mouseup', stopDrag);
    document.removeEventListener('touchmove', onDrag);
    document.removeEventListener('touchend', stopDrag);
  }

return (_ctx: any,_cache: any) => {
  return (__props.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "floating-button",
        ref_key: "floatingButton",
        ref: floatingButton,
        style: _normalizeStyle({ top: `${position.value.top}px`, left: `${position.value.left}px` }),
        onMousedown: startDrag,
        onTouchstart: startDrag
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 36))
    : _createCommentVNode("", true)
}
}

})